import { useState } from 'react';
import { ChevronLeftIcon, ChevronDownIcon } from '../components/Icons';

const LEGAL_SECTIONS = [
  {
    title: 'Privacy Policy',
    content: `At Manna Bridal, we respect your privacy and are committed to protecting your personal data. This Privacy Policy details how we collect, use, store, and share your personal information when you use our website or mobile application. 

We collect information you provide directly to us, including your name, email address, phone number, shipping address, and billing address. We only share your details with secure logistics partners and processing platforms essential to fulfilling your orders.`,
  },
  {
    title: 'Terms & Conditions',
    content: `By purchasing from Manna Bridal, you agree to comply with and be bound by our general Terms and Conditions. 

All designs, images, and brand materials are intellectual property of Manna Bridal. Prices of gowns and bridal accessories are subject to change without notice. We make every effort to display products as accurately as possible; however, variations in device displays may slightly alter colors or textures.`,
  },
  {
    title: 'Return & Cancellation Policy',
    content: `We want you to be completely satisfied with your purchase:
- Bridal Gowns & Accessories: These items are eligible for returns or exchanges within 14 days of delivery. All items must be unused, undamaged, and remain in their original premium packaging with all tags attached.
- Refunds: Approved returns will be refunded to your original payment method or stored as store credit within 5-7 business days of receipt at our warehouse.`,
  },
  {
    title: 'Shipping & Delivery Policy',
    content: `We offer countrywide premium insured shipping on all orders. Gowns are shipped in special protective bridal garment boxes to avoid crushing or wrinkling.

Standard orders take 24 to 48 hours for delivery, and we provide tracking information immediately after dispatch. Delivery updates are communicated via email and SMS.`,
  },
];

export default function LegalPage({ onNavigate }) {
  const [openIdx, setOpenIdx] = useState(0);

  const toggleSection = (idx) => {
    setOpenIdx(openIdx === idx ? null : idx);
  };

  return (
    <div className="min-h-screen bg-[#FAF3F0]">
      {/* Header */}
      <div className="flex items-center gap-3 px-4 lg:px-8 pt-5 pb-4 bg-[#FAF3F0]">
        <button onClick={() => onNavigate('account')} className="p-1.5 -ml-1.5 text-[#F47B20]">
          <ChevronLeftIcon className="w-6 h-6" />
        </button>
        <h1 className="text-lg font-bold text-[#1A1A2E]">Legal & Policies</h1>
      </div>

      <div className="px-4 lg:px-8 pb-28 lg:pb-12 max-w-2xl lg:max-w-4xl">
        <h2 className="text-xl font-black text-[#1A1A2E] mb-1">Manna Bridal Agreements</h2>
        <p className="text-gray-400 text-sm mb-6">Read about our policies, shipping agreements, and terms of service.</p>

        <div className="space-y-3">
          {LEGAL_SECTIONS.map((sec, idx) => {
            const isOpen = openIdx === idx;
            return (
              <div key={idx} className="bg-white rounded-2xl overflow-hidden border border-gray-100 shadow-sm transition-all">
                <button
                  onClick={() => toggleSection(idx)}
                  className="w-full flex items-center justify-between p-5 text-left font-bold text-[#1A1A2E] hover:bg-gray-50 transition-colors"
                >
                  <span className="text-base">{sec.title}</span>
                  <ChevronDownIcon
                    className={`w-5 h-5 text-[#F47B20] transition-transform duration-300 ${
                      isOpen ? 'rotate-180' : ''
                    }`}
                  />
                </button>
                {isOpen && (
                  <div className="px-5 pb-6 text-sm text-gray-500 leading-relaxed whitespace-pre-line border-t border-gray-50 pt-4">
                    {sec.content}
                  </div>
                )}
              </div>
            );
          })}
        </div>

        <div className="mt-8 text-center text-xs text-gray-400">
          Last updated: June 2026. For questions, contact support.
        </div>
      </div>
    </div>
  );
}
